import { DEAL_TYPES, PROMO_CODE_TYPES } from '../../../../../services/exports/Constants';

export default {
  title: 'Oferte speciale',
  view_more: 'Vezi mai multe',
  badges: {
    PROMO: 'Promoție',
    DEAL: 'Ofertă',
    'FREE ITEM': 'Produs gratuit',
    REWARDS: 'Recompense',
  },
  deals: {
    [DEAL_TYPES.GOOGLE_REVIEW_PROGRAM]: {
      title: '+{{reward}} Puncte extra',
      description: 'Evaluează-ne pe Google',
    },
    [DEAL_TYPES.SMART_PRICING_RULE]: {
      title: 'Ofertă specială',
      description: 'Aplicată automat',
    },
    buttons: {
      add: 'Adaugă',
      remove: 'Elimină',
      show_details: 'Arată detalii',
    },
    mobile_app_signup_bonus: {
      title: 'Bonus de înregistrare în aplicație {{amount}}',
      desc: 'Primești {{amount}} cashback când te autentifici în aplicația noastră.',
    },
    welcome_bonus: {
      title: 'Bonus de bun venit {{amount}}',
      desc: 'Primești {{amount}} cashback când te înregistrezi.',
    },
  },
  discounts: {
    title: 'Reducere {{discount}}',
    usage_threshold: '(Min: {{amount}})',
    description: {
      [PROMO_CODE_TYPES.ONE_TIME_PROMO_CODE]: 'Reducere {{discount}} la următoarea comandă - cod: {{code}}',
      [PROMO_CODE_TYPES.MULTI_PROMO_CODE]: 'Reducere {{discount}} la următoarele {{count}} comenzi - cod: {{code}}',
    },
  },
  feedback: {
    login:
      '<highlight>Autentifică-te</highlight> pentru a folosi această promoție, ca să verificăm că nu ai folosit-o deja. Autentifică-te și încearcă din nou.',
  },
};
